import { ApiProperty } from '@nestjs/swagger'
import { BaseEntityResponseDto } from '@sphere/shared/domain'

export class ActivityStateResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string', description: "Code unique de l'état" })
  code!: string

  @ApiProperty({ type: 'string', description: "Libellé de l'état" })
  label!: string
}

